const TPA_ALIAS = 'TPA_ALIAS';

export const setTpaAlias = (tpaAlias: string) => localStorage.setItem(TPA_ALIAS, tpaAlias);

export const getTpaAlias = () => localStorage.getItem(TPA_ALIAS);

export const deleteTpaAlias = () => localStorage.removeItem(TPA_ALIAS);
